import React from 'react';
import Image from '@/components/atoms/Image';
import Link from '@/components/atoms/link';
import { ArrowLongRightIcon as ArrowIcon } from '@heroicons/react/24/solid';
import { HeroTileProps } from './types';
import Hero from '../content/hero';

const HeroTile = ({data}:any) => {
  
  return (
    <Hero data={data} />
  );
};

export default HeroTile;
